<template>

	<span>
		<i class="fas" v-bind:class="'fa-' + this.iconByType(type)"></i>
		<span>{{ title }}</span>
		<span class="badge" v-if="number">{{ number }}</span>
	</span>

</template>

<script>
export default {
	props: {
		title: String,
		type: String,
		number: Number
	}
}
</script>